import { render, staticRenderFns } from "./Compose.SideNav.vue?vue&type=template&id=0a831c8c&scoped=true&"
import script from "./Compose.SideNav.vue?vue&type=script&lang=js&"
export * from "./Compose.SideNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a831c8c",
  null
  
)

export default component.exports